import { useEffect, useState } from "react";
import { Container, Modal, Table } from "../../../components";
import { dataTable, getPodadores } from "./handlers";
import { Link, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import { UserContext } from "../../../context/UserWrapper";
import { useContext } from "react";

export default function Podadores() {
  const { actions: ua } = useContext(UserContext);
  const nav = useNavigate();
  const [podadores, setPodadores] = useState({
    data: [],
    error: null,
    params: null,
    loading: false,
  });

  const headers = [
    { label: "ID", key: "id" },
    { label: "Nombre", key: "nombre" },
    { label: "DNI", key: "dni" },
    { label: "Teléfono", key: "telefono" },
    { label: "Información Adicional", key: "info" },
    { label: "Estado", key: "estado_nombre" },
  ];

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (ua.hasRole("admin.app")) {
      getPodadores(podadores, setPodadores);
    } else {
      nav("/");
    }
  }, []);

  return (
    <Container linkBack={"/admin"} titulo={"Podadores"}>
      {!podadores.data && podadores.loading && (
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      )}
      {podadores.data && (
        <Table
          search={true}
          data={dataTable(podadores.data)}
          loading={podadores.loading}
          render={() => {
            return (
              <div className="d-flex justify-content-center">
                <Link
                  className="btn btn-sm btn-primary mt-2 mb-2 mx-2 d-flex align-items-center"
                  to="/crear_podador"
                  disabled={podadores.loading}
                >
                  Crear Podador
                </Link>
                <CSVLink
                  className="btn btn-success btn-sm mt-2 mb-2 mx-2 d-flex align-items-center gap-2"
                  headers={headers}
                  filename={"listado-podadores.csv"}
                  data={podadores.data}
                  separator={";"}
                  disabled={podadores.loading}
                >
                  <span>Descargar Podadores</span>
                </CSVLink>
              </div>
            );
          }}
        />
      )}
    </Container>
  );
}
